import Report from '@mui/icons-material/Report';
import { Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import InformacoesAppBackend from './InformacoesAppBackend';
import ReactComponent from './ReactComponent';

class TelaErro extends ReactComponent {
    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: '1',
                    alignItems: 'center',
                    padding: '2em'
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Fragment>
                        <Report style={{ width: '96px', height: '96px', fill: red[800] }} />
                        <Typography style={{ fontSize: 'larger', fontWeight: 'bold', color: '#C62828' }}>
                            FALHA INESPERADA
                        </Typography>
                        <Typography style={{ color: '#C62828', fontStyle: 'italic' }}>
                            Tente novamente mais tarde. Se o problema persistir, contacte o administrador do sistema.
                        </Typography>
                    </Fragment>
                    <div style={{ width: '100%' }}>
                        <InformacoesAppBackend></InformacoesAppBackend>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(TelaErro));
